import Vue from 'vue'
import 'bootstrap'
import './assets/vendor/jquery-easing/jquery.easing.min.js'

if ( process.env.VUE_APP_BRAND !== 'ikea'){
  require('./assets/js/jqBootstrapValidation.min.js')
  require('./assets/js/contact_me.min.js')
  require('./assets/js/agency.min.js')
}

const App = () => import('./App.vue')
const Navigation = () => import('./views/Navigation.vue')
const ChapterNav = () => import('./views/ChapterNav.vue')
const EmptyNav = () => import('./views/EmptyNav.vue')
const LogoNav = () => import('./views/LogoNav.vue')
const Footer = () => import('./views/Footer.vue')
const Loading = () => import('./views/Loading.vue')
const Error = () => import('./views/Error.vue')

import router from './router'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie'
if ( process.env.VUE_APP_BRAND !== 'ikea'){
  const VueGoogleMaps = require('vue2-google-maps')
  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyCplRKRYzATji6CvFz13HI0yVppJPj_A_s',
      libraries: 'places', // This is required if you use the Autocomplete plugin
    },
  })
  Vue.component('google-map', VueGoogleMaps.Map);
  Vue.component('google-marker', VueGoogleMaps.Marker);
}
import VueAnalytics from 'vue-analytics'

// Vee validate bundle
//import { Validator, install as VeeValidate } from 'vee-validate/dist/vee-validate.minimal.esm.js';
//import { required, numeric, regex, digits, email } from 'vee-validate/dist/rules.esm.js';
//Validator.extend('required', required);
//Validator.extend('numeric', numeric);
//Validator.extend('regex', regex);
//Validator.extend('digits', digits);
//Validator.extend('email', email);

import VeeValidate from 'vee-validate';

Vue.config.productionTip = false
Vue.config.performance = true
Vue.use(VueCookie)
Vue.use(VueResource)
Vue.use(VeeValidate)
Vue.use(VueAnalytics, {
  id: 'UA-140221403-1',
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
})
Vue.component('navigation', Navigation)
Vue.component('chapternav', ChapterNav)
Vue.component('emptynav', EmptyNav)
Vue.component('logonav', LogoNav)
Vue.component('loading', Loading)
Vue.component('purealm-footer', Footer)
Vue.component('error', Error)

Vue.filter('thousandsSeparators', function(value) {
  if (value || parseInt(value) === 0) {
    if (parseInt(value) < 0) {
      return 0;
    }
    return parseInt(value).toLocaleString();
  }
})

//css
import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/fontawesome-free/css/all.min.css';
import './assets/css/fonts.min.css';
import './assets/css/base.min.css';
import './assets/css/tooltip.min.css';

if ( process.env.VUE_APP_BRAND ) {
  if ( process.env.VUE_APP_BRAND == 'ikea-taoyuan' ) {
    require('./assets/css/ikea.min.css');   
  } else {
    require('./assets/css/' + process.env.VUE_APP_BRAND + ".min.css");
  }
} else {
  require('./assets/css/parkit.min.css');
}
import './assets/css/animate.min.css';

new Vue({
  router,
  data() {
    return {
      loading: false 
    }
  },
  render: h => h(App),
}).$mount('#app')
